module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-4 col-sm-10"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'marker',
        params: {
          markerId: _vm.marker.id
        }
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.getLocalizedProp(_vm.marker.name)))])]), _vm._v(" "), _c('router-link', {
    staticClass: "glyphicon glyphicon-pencil clickable edit",
    attrs: {
      "aria-hidden": "true",
      "tag": "span",
      "to": {
        path: ("/marker/" + (_vm.marker.id) + "/edit")
      }
    }
  }), _vm._v(" "), _c('confirm-modal', {
    staticClass: "trash-marker",
    attrs: {
      "cancel-label": _vm.$t('cancel'),
      "confirm-label": _vm.$t('delete')
    },
    on: {
      "confirm": function($event) {
        return _vm.deleteMarker(_vm.marker)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-trash clickable edit",
    attrs: {
      "slot": "trigger",
      "aria-hidden": "true"
    },
    slot: "trigger"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('marker.delete_confirmation')))]), _vm._v(" "), _c('div', {
    staticClass: "well"
  }, [_vm._v(_vm._s(_vm.getLocalizedProp(_vm.marker.name)))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-6 col-xs-6"
  }, [_c('span', {
    staticClass: "visible-sm-inline visible-xs"
  }, [_vm._v(_vm._s(_vm.$t('marker.targeted_groups'))), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('spacing'))
    }
  }), _vm._v(":")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.joined_targeted_groups))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-6 col-xs-6"
  }, [_c('span', {
    staticClass: "visible-sm-inline visible-xs"
  }, [_vm._v(_vm._s(_vm.$t('marker.start_date'))), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('spacing'))
    }
  }), _vm._v(":")]), _vm._v(" "), _c('date', {
    attrs: {
      "value": _vm.marker.starts_at
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-6 col-xs-6"
  }, [_c('span', {
    staticClass: "visible-sm-inline visible-xs"
  }, [_vm._v(_vm._s(_vm.$t('marker.end_date'))), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('spacing'))
    }
  }), _vm._v(":")]), _vm._v(" "), _c('date', {
    attrs: {
      "value": _vm.marker.ends_at
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-12"
  }, [_vm._v("\n    " + _vm._s(_vm.marker.records_count) + "\n    "), _c('span', {
    staticClass: "visible-sm-inline visible-xs-inline"
  }, [_vm._v(" " + _vm._s(_vm.$tc('records.video', _vm.marker.records_count >= 2 ? 2 : 1)))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-108414e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/markersList/MarkerRow.vue
// module id = 1019
// module chunks = 1